import React, { FC, Suspense, useEffect } from 'react';
import {
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from 'react-router-dom';
import { useAppDispatch } from '../services/types/store-types';

// Импорты несвязанных компонентов
import { Header } from '../components/header/header';
import { Sidebar } from '../components/sidebar/sidebar';
import { Footer } from '../components/footer/ui/footer';
import { ProtectedRoute } from '../components/protected-route/protected-route';
import DevicePage from '../pages/device-page/device-page';
// Импорты для локализации и RPC
import { clearSelectNodes } from '../services/slices/tree';
import ErrorBoundary from '../components/ErrorBoundary';
import { ProgressSpinner } from 'primereact/progressspinner';

// Ленивая загрузка страниц
const AuthPage = React.lazy(() => import('../pages/auth-page/auth-page'));
const Consumption = React.lazy(
  () => import('../pages/consumption-page/consumption-page')
);
const Log = React.lazy(() => import('../pages/log-page/log-page'));
const Config = React.lazy(() => import('../pages/config-page/config-page'));
const ExportPage = React.lazy(() => import('../pages/export-page/export-page'));
const ReportPage = React.lazy(() => import('../pages/report-page/report-page'));
const GraphPage = React.lazy(() => import('../pages/graph-page/graph-page'));
const BalancePage = React.lazy(
  () => import('../pages/balance-page/balance-page')
);
const PlannerPage = React.lazy(
  () => import('../pages/planner-page/planner-page')
);
const OperatorPage = React.lazy(
  () => import('../pages/operator-page/operator-page')
);
const VtiPage = React.lazy(() => import('../pages/vti-page/vti-page'));
const DynamicDevicePage = React.lazy(
  () => import('../pages/device-page/device-page')
);
const DynamicManualPage = React.lazy(
  () => import('../pages/manual-page/manual-page')
);

export const Router: FC = () => {
  const dispatch = useAppDispatch();
  const nav = useNavigate();
  const location = useLocation(); // Получаем текущий URL
  const authToken = localStorage.getItem('authToken');

  useEffect(() => {
    dispatch(clearSelectNodes());

    if (authToken && location.pathname === '/') {
      nav('/device');
    }
  }, [dispatch, location]);

  return (
    <>
      {authToken && (
        <>
          <Sidebar />

          <div className="resurs__application">
            <Header />
            <ErrorBoundary>
              <Suspense
                fallback={
                  <div
                    style={{
                      height: '100%',
                      width: '100%',
                    }}
                  >
                    <ProgressSpinner />
                  </div>
                }
              >
                <Routes>
                  <Route
                    path="/"
                    element={<Navigate to="/device" replace={true} />}
                  />
                  <Route
                    path="/device"
                    element={
                      <ProtectedRoute>
                        <DevicePage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/manual"
                    element={
                      <ProtectedRoute>
                        <DynamicManualPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/export"
                    element={
                      <ProtectedRoute>
                        <ExportPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/consumption"
                    element={
                      <ProtectedRoute>
                        <Consumption />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vti"
                    element={
                      <ProtectedRoute>
                        <VtiPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/log"
                    element={
                      <ProtectedRoute>
                        <Log />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/config"
                    element={
                      <ProtectedRoute>
                        <Config />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/report"
                    element={
                      <ProtectedRoute>
                        <ReportPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/graph"
                    element={
                      <ProtectedRoute>
                        <GraphPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/balance"
                    element={
                      <ProtectedRoute>
                        <BalancePage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/planner"
                    element={
                      <ProtectedRoute>
                        <PlannerPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/operator"
                    element={
                      <ProtectedRoute>
                        <OperatorPage />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Suspense>
            </ErrorBoundary>
            <Footer />
          </div>
        </>
      )}

      {!authToken && (
        <Routes>
          <Route path="*" element={<AuthPage />} />
        </Routes>
      )}
    </>
  );
};
